import React from 'react';
import './styles.scss';
import {
  useConfigStore,
  useInterfaceStore,
  useChatStore,
} from '@/hooks/stores';
import Components from './components';
import { useCustomComponent } from '@/hooks';

export interface WidgetButtonProps {}

const WidgetButtonComponent: React.FC<WidgetButtonProps> = () => {
  const {
    ui: { icon },
  } = useConfigStore();
  const { widgetIsOpen, toggleWidgetOpen } = useInterfaceStore();
  const { isFormSubmitting, unreadCount } = useChatStore();

  const isImageIcon =
    icon.startsWith('http') || icon.startsWith('data:') || icon.startsWith('/');

  // Hide button when widget is open - user can only close via header button
  if (widgetIsOpen) {
    return null;
  }

  return (
    <Components.Root
      className="peptalk-widget-button"
      onClick={toggleWidgetOpen}
      disabled={isFormSubmitting}
    >
      <div className="peptalk-widget-button-content">
        <Components.IconContainer className="visible peptalk-widget-button-icon-container">
          <Components.OpenIcon isImageIcon={isImageIcon} icon={icon} />
        </Components.IconContainer>

        {/* Close state icon */}
        <Components.IconContainer
          className={`peptalk-widget-button-icon-container ${widgetIsOpen ? 'visible' : 'hidden'}`}
        >
          <Components.CloseIcon />
        </Components.IconContainer>
      </div>

      {unreadCount > 0 && (
        <span className="peptalk-widget-button-badge">
          {unreadCount > 5 ? '5+' : unreadCount}
        </span>
      )}
    </Components.Root>
  );
};

export const WidgetButton: React.FC<WidgetButtonProps> = (
  props: WidgetButtonProps
) => {
  const Component = useCustomComponent({
    componentName: 'WidgetButton',
    Component: WidgetButtonComponent,
  });

  return <Component {...props} />;
};
